import { gql } from 'graphql-request';

export const LOGOUT_USER_QUERY = gql`
  mutation LogoutUser($clientMutationId: String!) {
    logoutUser(input: { clientMutationId: $clientMutationId }) {
      status
    }
  }
`;
